import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '../base';
import CloudinaryPicture from './cloudinaryPicture';
import HtmlContent from './htmlContent';

/**
 * Image + text rows on content pages (the former Prismic "bio" slices,
 * now the `bio` frontmatter list in src/content/pages/*.md).
 */
const BioSections = (props) => {
  if (!props.bio || props.bio.length === 0) {
    return null;
  }

  return (
    <>
      {props.bio.map((item) => (
        <Grid.Row className="mt-3" key={item.imageKey}>
          <Grid.Col xs={3}>
            <CloudinaryPicture imageKey={item.imageKey} className="mw-100" />
          </Grid.Col>
          <Grid.Col xs={9}>
            <HtmlContent html={item.text} />
          </Grid.Col>
        </Grid.Row>
      ))}
    </>
  );
};

BioSections.propTypes = {
  bio: PropTypes.arrayOf(
    PropTypes.shape({
      imageKey: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
};

export default BioSections;
